export default __webpack_public_path__ + "assets/thunderstorms-snow.40d7240a.svg";